// Unit definitions organized by category
export const UNIT_CATEGORIES = {
  LENGTH: 'length',
  MASS: 'mass',
  FORCE: 'force',
  ENERGY: 'energy',
  POWER: 'power',
  PRESSURE: 'pressure',
  TEMPERATURE: 'temperature',
  TIME: 'time',
  VOLUME: 'volume',
  ANGLE: 'angle',
  AREA: 'area',
};

export const UNITS = {
  length: {
    meter: { symbol: 'm', toBase: 1 },
    kilometer: { symbol: 'km', toBase: 1000 },
    centimeter: { symbol: 'cm', toBase: 0.01 },
    millimeter: { symbol: 'mm', toBase: 0.001 },
    micrometer: { symbol: 'μm', toBase: 0.000001 },
    nanometer: { symbol: 'nm', toBase: 0.000000001 },
    mile: { symbol: 'mi', toBase: 1609.344 },
    yard: { symbol: 'yd', toBase: 0.9144 },
    foot: { symbol: 'ft', toBase: 0.3048 },
    inch: { symbol: 'in', toBase: 0.0254 },
    nauticalMile: { symbol: 'nmi', toBase: 1852 },
  },
  mass: {
    kilogram: { symbol: 'kg', toBase: 1 },
    gram: { symbol: 'g', toBase: 0.001 },
    milligram: { symbol: 'mg', toBase: 0.000001 },
    metricTon: { symbol: 't', toBase: 1000 },
    pound: { symbol: 'lb', toBase: 0.45359237 },
    ounce: { symbol: 'oz', toBase: 0.028349523125 },
    ton: { symbol: 'ton', toBase: 907.18474 },
    stone: { symbol: 'st', toBase: 6.35029318 },
  },
  force: {
    newton: { symbol: 'N', toBase: 1 },
    kilonewton: { symbol: 'kN', toBase: 1000 },
    poundForce: { symbol: 'lbf', toBase: 4.4482216152605 },
    kilopoundForce: { symbol: 'kip', toBase: 4448.2216152605 },
    dyne: { symbol: 'dyn', toBase: 0.00001 },
  },
  energy: {
    joule: { symbol: 'J', toBase: 1 },
    kilojoule: { symbol: 'kJ', toBase: 1000 },
    calorie: { symbol: 'cal', toBase: 4.184 },
    kilocalorie: { symbol: 'kcal', toBase: 4184 },
    wattHour: { symbol: 'Wh', toBase: 3600 },
    kilowattHour: { symbol: 'kWh', toBase: 3600000 },
    electronvolt: { symbol: 'eV', toBase: 1.602176634e-19 },
    btu: { symbol: 'BTU', toBase: 1055.05585262 },
    footPound: { symbol: 'ft·lb', toBase: 1.3558179483314004 },
  },
  power: {
    watt: { symbol: 'W', toBase: 1 },
    kilowatt: { symbol: 'kW', toBase: 1000 },
    megawatt: { symbol: 'MW', toBase: 1000000 },
    horsepower: { symbol: 'hp', toBase: 745.69987158227022 },
    btuPerHour: { symbol: 'BTU/h', toBase: 0.29307107017222222 },
  },
  pressure: {
    pascal: { symbol: 'Pa', toBase: 1 },
    kilopascal: { symbol: 'kPa', toBase: 1000 },
    bar: { symbol: 'bar', toBase: 100000 },
    atmosphere: { symbol: 'atm', toBase: 101325 },
    psi: { symbol: 'psi', toBase: 6894.7572931783 },
    torr: { symbol: 'torr', toBase: 133.322368421 },
    mmHg: { symbol: 'mmHg', toBase: 133.322387415 },
  },
  temperature: {
    celsius: { symbol: '°C', isSpecial: true },
    fahrenheit: { symbol: '°F', isSpecial: true },
    kelvin: { symbol: 'K', isSpecial: true },
  },
  time: {
    second: { symbol: 's', toBase: 1 },
    millisecond: { symbol: 'ms', toBase: 0.001 },
    microsecond: { symbol: 'μs', toBase: 0.000001 },
    nanosecond: { symbol: 'ns', toBase: 0.000000001 },
    minute: { symbol: 'min', toBase: 60 },
    hour: { symbol: 'h', toBase: 3600 },
    day: { symbol: 'd', toBase: 86400 },
    week: { symbol: 'wk', toBase: 604800 },
    month: { symbol: 'mo', toBase: 2629800 },
    year: { symbol: 'yr', toBase: 31557600 },
  },
  volume: {
    liter: { symbol: 'L', toBase: 1 },
    milliliter: { symbol: 'mL', toBase: 0.001 },
    cubicMeter: { symbol: 'm³', toBase: 1000 },
    cubicCentimeter: { symbol: 'cm³', toBase: 0.001 },
    gallon: { symbol: 'gal', toBase: 3.785411784 },
    quart: { symbol: 'qt', toBase: 0.946352946 },
    pint: { symbol: 'pt', toBase: 0.473176473 },
    cup: { symbol: 'cup', toBase: 0.236588236 },
    fluidOunce: { symbol: 'fl oz', toBase: 0.0295735295625 },
    tablespoon: { symbol: 'tbsp', toBase: 0.01478676478125 },
    teaspoon: { symbol: 'tsp', toBase: 0.00492892159375 },
  },
  angle: {
    degree: { symbol: '°', toBase: 1 },
    radian: { symbol: 'rad', toBase: 57.2957795130823 },
    gradian: { symbol: 'grad', toBase: 0.9 },
    arcminute: { symbol: "'", toBase: 0.0166666666666667 },
    arcsecond: { symbol: '"', toBase: 0.000277777777777778 },
    turn: { symbol: 'turn', toBase: 360 },
  },
  area: {
    squareMeter: { symbol: 'm²', toBase: 1 },
    squareKilometer: { symbol: 'km²', toBase: 1000000 },
    squareCentimeter: { symbol: 'cm²', toBase: 0.0001 },
    squareMillimeter: { symbol: 'mm²', toBase: 0.000001 },
    hectare: { symbol: 'ha', toBase: 10000 },
    acre: { symbol: 'ac', toBase: 4046.8564224 },
    squareMile: { symbol: 'mi²', toBase: 2589988.110336 },
    squareYard: { symbol: 'yd²', toBase: 0.83612736 },
    squareFoot: { symbol: 'ft²', toBase: 0.09290304 },
    squareInch: { symbol: 'in²', toBase: 0.00064516 },
    // Korean unit '평' (pyeong) — 1 pyeong = 3.305785 m²
    pyeong: { symbol: '평', toBase: 3.305785 },
  },
};
